module.exports = __webpack_public_path__ + "media/images/rabbit-b9d9471e2f5c0c38b9a9338de492a105.svg";